import * as React from 'react';
import { connect } from 'react-redux';
import LoginForm from '../components/LoginForm';
import { StoreState } from '@ui/store/rootReducer';
import { actions, authSelectors } from '@ui/store/auth';

import './Login.less';

interface DispatchToProps {
  onLogin: (login: string, password: string) => void;
}

interface StateToProps {
  error: string;
  loading: boolean;
}

type Props = DispatchToProps & StateToProps;

class Login extends React.PureComponent<Props> {
  render() {
    const { onLogin, error, loading } = this.props;
    return (
      <div className="login-page">
        <div className="page-background" />
        <LoginForm onSubmit={onLogin} error={error} loading={loading} />
      </div>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  error: authSelectors.getError(state),
  loading: authSelectors.getLoading(state),
});

const mapDispatchToProps: DispatchToProps = {
  onLogin: actions.loginRequested,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login);



// WEBPACK FOOTER //
// ./src/scenes/Login/containers/Login.tsx